module.exports = __webpack_public_path__ + "img/popup_bg.c2757694.jpg";